(function ($) {
  "use strict";

  // This code notifies Google Tag Manager when a wpForm is submitted
  document.addEventListener("DOMContentLoaded", function () {
    var elementsArray = document.querySelectorAll('[id^="wpforms-form-"]');
    elementsArray.forEach(function (elem) {
      elem.addEventListener("submit", function (e) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "wpFormSubmit",
          wpFormElement: event.target,
        });
      });
    });

    const sections = document.querySelectorAll('.fly-in-media-text');

    sections.forEach(section => {
      const images = section.querySelectorAll('.fly-in-image img');

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
          }
        });
      }, {
        rootMargin: '100px',
        threshold: 0
      });

      images.forEach(img => observer.observe(img));
    });
  });


  $(document).ready(function () {
    // There may be multiple 'nav' elements - change this to depend on your circumstances
    $("button.hamburger").on("click", function () {
      $("button.hamburger").toggleClass("is-active");
      $("body").toggleClass("show-mobile-menu");
    });

    $(".hero-video-link").on("click", function () {
      $(".hero-video-lightbox").addClass("active");
    });

    $(".hero-video-lightbox-close").on("click", function () {
      $(".hero-video-lightbox").removeClass("active");
    });

    $(document).keydown(function (event) {
      if (event.which == 27) $(".hero-video-lightbox").removeClass("active");
    });

    $(".trial_cta_button").on("touchstart touchend", function (e) {
      $(this).toggleClass("hover-effect");
    });

    $(".ultra-stories-carousel").marmeloSlide({
      containerClass: ".ultra-stories-carousel-content",
      itemClass: ".slide",
      minNumber: 1,
    });

    const scrollContainer =
      $("body.para-drop").length > 0 ? $("#wrapper") : $(window);
    // $('#wrapper').scroll( function() {
    scrollContainer.scroll(function () {
      //if($('#wrapper').scrollTop() > ($(window).height() / 4))
      if (scrollContainer.scrollTop() > $(window).height() / 4)
        $(".floating-cta-wrapper").addClass("active");
      else $(".floating-cta-wrapper").removeClass("active");
    });
  });
})(jQuery);

// const arc = document.getElementById("arc");

// function positionArc() {
//   if (!arc) return;

//   const nodes = [...arc.querySelectorAll(".step-icon-item")];

//   // Grid configuration
//   const gridSize = 8; // 8x8 grid
//   let col = 1;
//   let row = 1;

//   nodes.forEach((node, i) => {
//     node.style.gridColumn = col;
//     node.style.gridRow = row;

//     col++;
//     if (col > gridSize) {
//       col = 1;
//       row++;
//     }
//   });
// }

// // Position arc on page load
// positionArc();

// // Reposition arc on window resize
// window.addEventListener("resize", positionArc);
